import React from 'react';
import classNames from 'classnames';
import twitter from './twitter.svg';
import facebook from './facebook.svg';
import linkedin from './linkedin.svg';
import youtube from './youtube.svg';
import contact from './contact.svg';
import styles from './footer.module.scss';

const channels = [
  {
    href: 'https://twitter.com/teamgantt',
    logo: twitter,
  },
  {
    href: 'https://www.facebook.com/pages/TeamGantt/267785880859',
    logo: facebook,
  },
  {
    href: 'https://www.linkedin.com/company/teamgantt',
    logo: linkedin,
  },
  {
    href: 'https://www.youtube.com/user/teamgantt',
    logo: youtube,
  },
  {
    href: 'https://www.teamgantt.com/contact-us/',
    logo: contact,
  },
];

const Social = () => (
  <ul className={classNames('is-flex', styles.Footer__socialLinks)}>
    {channels.map(({href, logo}, i) => (
      <li className={styles.Footer__socialLink} key={`social-${i}`}>
        <a href={href}>
          <img src={logo} />
        </a>
      </li>
    ))}
  </ul>
);

export default Social;



// WEBPACK FOOTER //
// ./src/components/footer/Social.js